<template>
  <div>
    <header class="header">
      <div class="header-left">
        <a>
          <img src="/static/image/top_bg_right-1.png" />
        </a>
      </div>
      <div class="top-right">
        <div class="user-login" v-if="$store.state.token">
          <a @click="$parent.goNav('/')">{{ $t('header.home') }}</a> &nbsp;|&nbsp;
          <a class="shiwan" @click="$parent.goNav('/mine/center')">{{ $store.state.userInfo.username ? $store.state.userInfo.username : '' }}</a>
          &nbsp;|&nbsp; <a @click="outLogin">{{ $t('header.Signout') }}</a>
        </div>
        <div class="user-login" v-else>
          <a @click="$parent.goNav('/')"
            ><font style="vertical-align: inherit"
              ><font style="vertical-align: inherit">{{ $t('header.home') }}</font></font
            ></a
          ><font style="vertical-align: inherit"
            ><font style="vertical-align: inherit"> &nbsp;| </font><font style="vertical-align: inherit">{{ $t('header.Notmember') }} </font></font
          ><a @click="$parent.goNav('/register')"
            ><font style="vertical-align: inherit"
              ><font style="vertical-align: inherit">{{ $t('header.register') }}</font></font
            ></a
          >
        </div>
      </div>

      <img style="margin-top: -55px" class="header-logo" src="/static/image/logo1-1.png" />
    </header>
    <div class="app-content view-slideup on" v-if="show">
      <div class="activity-city">
        <div class="form-result">
          <ul id="applyResult" class="app-ul">
            <li class="app-li" style="border-bottom: 1px solid rgb(170, 170, 170); line-height: 40px">
              <div class="app-col-time" style="color: rgb(204, 163, 82); width: 20%">{{ $t('mine.ApplicationTime') }}</div>
              <div class="app-col-content" style="text-align: center; color: rgb(204, 163, 82)">{{ $t('mine.Applycontent') }}</div>
              <div class="app-col-progress" style="color: rgb(204, 163, 82)">{{ $t('mine.Auditresult') }}</div>
            </li>
            <div id="result" style="color: rgb(51, 51, 51)">
              <li class="app-li" v-for="(item, index) in activityApplyLogList" :key="index">
                <div class="app-col-time" style="width: 20%">{{ item.created_at }}</div>
                <div class="app-col-content" style="text-align: center">{{ item.activity_name }}</div>
                <div class="app-col-progress">{{ statuTypeS[item.state] }}</div>
              </li>
            </div>
            <!-- <p style="color: rgb(153, 153, 153); text-align: center; font-size: 13px">默认显示近10次申请，更多请联系客服</p> -->
          </ul>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="content">
        <div class="sponsors"></div>
        <div class="foot-nav">
          <div class="copyright all-rights">© 2022 {{ $store.state.appInfo.title }} {{ $t('foot.All') }}.</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'activityapyList',
  data() {
    return { show: false, activityApplyLogList: [], statuTypeS: ['未约定', '待审核', '通过', '拒绝', '未约定'] };
  },
  created() {
    let that = this;
    that.statuTypeS = [that.$t('mine.undefined'),that.$t('mine.reviewed'),that.$t('mine.Approved'),that.$t('mine.Audit'),that.$t('mine.undefined')]
    that.getactivityApplyLogList();
  },
  methods: {
    outLogin() {
      let that = this;
      that.$parent.outLogin();
    },
    // 获取活动申请记录
    getactivityApplyLogList() {
      let that = this;
      that.$parent.showLoading();
      let info = {
        limit: 999,
        page: 1,
      };
      that.$apiFun
        .post('/api/activityApplyLog', {})
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.activityApplyLogList = res.data.data;
          }
          that.$parent.hideLoading();
          that.show = true;
        })
        .catch(res => {
          that.show = true;
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/announcement_modal.css';
@import '../../static/css/style.css';
@import '../../static/css/bootstrap.min.css';

.header-logo {
  width: auto;
  // height: 115px;
  margin: -69px auto 0 auto;
  display: inherit;
}
.app-content {
  top: 90px;
  margin-bottom: 150px;
}
.activity-content {
  width: 100%;
  margin: 0 auto;
  border: 1px solid #ba924a;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 0 20px #000;
  background: #f5f5f5;
}
#result {
  font-size: 16px;
  padding: 10px 0;
  color: #aaa;
}
.activity-city {
  width: 800px;
}
#result li {
  line-height: 35px;
}
.activity-sub {
  width: 100%;
  margin: 0 auto;
  border: 1px solid #ba924a;
  border-radius: 5px;
  margin-top: 15px;
  margin-bottom: 15px;
  padding-bottom: 15px;
  display: -webkit-box;
}
.form-input {
  display: block;
  width: 100%;
  height: 34px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 3px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  color: #000;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  padding: 6px 12px;
}
.from-title {
  line-height: 40px;
  font-size: 15px;
  color: #ccc;
  font-weight: 400;
}
.form-control,
.form-input {
  height: 45px;
  line-height: 45px;
  font-size: 16px;
}
.form-btn {
  margin-top: 50px;
  line-height: 40px;
  height: 40px;
  border-radius: 3px;
  left: 50%;
  margin-left: -115px;
}
.form-group {
  -webkit-box-flex: 1;
  position: relative;
  max-width: 350px;
  margin: 80px auto 0 auto;
}
.free-dem-a {
  color: #fff;
  font-size: 16px;
  font-weight: 400;
}
.free-demo {
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  display: block;
  width: 230px;
  height: 44px;
  float: left;
  text-align: center;
  line-height: 44px;
  background: #cca352;
  position: relative;
  transition: all 0.2s;
  overflow: hidden;
}
.free-dem-a {
  color: #fff;
  font-size: 16px;
}
.free-demo:after {
  content: '';
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.2);
  transform: rotate(-45deg);
  position: absolute;
  top: -10%;
  left: -100%;
  transition: 0.6s ease;
}
.free-demo:hover {
  background: #ba8d4d;
}
.free-demo:hover:after {
  animation: cv-submit-hover 0.8s ease;
}

@keyframes cv-submit-hover {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
.group-content {
  width: 80%;
  max-width: 300px;
  position: absolute;
  right: 0;
}
.activity-image {
  margin-bottom: 5px;
}
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 9;
}

.image-back {
  top: 72px;
  height: 500px;
}

.app-group {
  display: none;
}

.form-result {
  -webkit-box-flex: 1;
  position: relative;
  margin: 10px auto 0 auto;
}

.app-ul {
  background: #f9f9f9;
  border-radius: 3px;
  overflow: hidden;
  padding: 20px;
}

.app-li {
  font-size: 15px;
  display: -webkit-box;
  display: -moz-box;
  line-height: 30px;
}

.app-col-time {
  width: 110px;
  text-align: center;
}

.app-col-content {
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.app-col-progress {
  width: 110px;
  text-align: center;
}
.app-col-tip {
  width: 250px;
  text-align: center;
}
.form-control,
.form-input {
  height: 38px;
  line-height: 38px;
  font-size: 16px;
}
.activity-image {
  display: block;
}
.activity-image1 {
  display: none;
}
.app-li.app-col-tip1 {
  display: none;
}
@media screen and (max-width: 768px) {
  .header-logo {
    display: none;
  }
  .app-content {
    top: 60px;
  }
  .image-back {
    top: 45px;
  }
  .activity-image {
    width: 170%;
    margin-left: -47.7%;
    border-radius: 5px;
    overflow: hidden;
  }
  .form-group {
    max-width: 75%;
    margin: 50px auto 0 auto;
  }
  .image-back {
    height: 300px;
  }
  .form-control,
  .form-input {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
  }
  .app-col-time {
    width: 80px;
    text-align: center;
  }

  .app-col-content {
    -webkit-box-flex: 1;
    -moz-box-flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .app-col-progress {
    width: 75px;
    text-align: center;
  }

  .activity-city {
    width: 100%;
  }
  .activity-image {
    display: none;
  }
  .activity-image1 {
    display: block;
    width: 100%;
  }

  .app-col-tip {
    display: none;
  }

  .app-li div {
    font-size: 13px;
  }

  .app-li.app-col-tip1 {
    display: block;
    font-size: 13px;
    color: #888;
    text-align: center;
    background: #f5f5f9;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/activityapyList.vue